import React from 'react';
import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import imgWyNow from "../assets/img/wy-now.webp";
import projImg2 from "../assets/img/FW-Logo.png";
import projImg3 from "../assets/img/FW-Logo.png";
import projImg4 from "../assets/img/YR-Venture-Logo.png";
import colorSharp2 from "../assets/img/color-sharp2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Projects = () => {

  const projects = [
    {
      title: "Wy-now.com",
      description: "Design & Développement",
      href: "#projects",
      imgUrl: imgWyNow,
    },
    {
      title: "Template hébergeur",
      description: "Design & Développement",
      href: "#projects",
      imgUrl: projImg2,
    },
    {
      title: "OpenFramework",
      description: "Développement du framework PHP",
      href: "https://github.com/2fl00rian6/openFramework/",
      imgUrl: projImg3,
    },
    {
      title: "YR-Venture",
      description: "Développement front-end avec ReactJS",
      href: "https://yr-venture.com/",
      imgUrl: projImg4,
    },
  ];

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                <h2>Projects</h2>
                <p>Aucun projet de ce type est répertorier</p>
                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                  <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                    <Nav.Item>
                      <Nav.Link eventKey="first">Projets web</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">Projets mobiles</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="third">Projets mixtes</Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                    <Tab.Pane eventKey="first">
                      <Row>
                        {
                          projects.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="second">
                      <p>Aucun projet de ce type est répertorier</p>
                    </Tab.Pane>
                    <Tab.Pane eventKey="third">
                      <p>Aucun projet de ce type est répertorier</p>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2}></img>
    </section>
  )
}
